module.exports = __webpack_public_path__ + "c6bc4665e1ef39797084728c13126674.svg";